export const gotoAppPalette = {
    'green-100': '#B9F1BD',
    'green-200': '#83DE89',
    'green-300': '#4CD155',
    'green-400': '#11AB1B',
    'green-500': '#008409',
    'green-600': '#006707',
    'green-700': '#005005',
};
